import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'location-formater'
})

export class CharacterRemoverPipe implements PipeTransform {

  transform(field: string, chars: any): string {
	return field.split('').map(i => chars.includes(i) ? '' : i).join("");
  }

}
